<ln-ln-pages-armor>
  <section body class="font-['Roboto']  sm:border-t-[1.8px] sm:border-t-beige bg-beige bg-opacity-15 sm:border-t-opacity-10 sm:shadow-[0_-2px_4px_rgba(0,0,0,0.05)]">
    <div class="max-w-[1440px] mx-auto">

        <button (click)="GoHome()" class="flex items-center mx-[31px] sm:mx-[120px] pt-[22px] sm:pt-[0px] mt-[15px] mb-[20px] hover:scale-110 transition duration-100">
          <ln-ln-arrow-back-svg-icon [class]="'h-[24px] w-[p4px]'"></ln-ln-arrow-back-svg-icon>
          <span class="hidden sm:block text-cafe text-base font-normal font-['Roboto'] ml-[6px]">{{'buttons.goHome' | transloco}}</span>
        </button>

      <ln-shopping-car-body></ln-shopping-car-body>

      <div class="flex sm:mx-[68px] items-center  border-b-[2px] opacity-40 border-b-verde"></div>
    </div>

  </section>
</ln-ln-pages-armor>
